export enum PodcastBHCustomEventCategory {
  ARTICLE_PAGE = "article page podcast widget",
  PODCAST_PAGE = "podcast",
  HOME_PAGE = "podcast widget",
}

export type BHCustomEventPodcastProps = {
  eventCategory: PodcastBHCustomEventCategory;
  eventAction: "click" | "play";
  eventLabel?: string;
};
